import { Grid,Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Autocomplete, TextField, TableFooter } from '@mui/material'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useStyle } from '../style'
import axios from 'axios'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import _ from 'lodash'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from 'moment'
import * as XLSX from 'xlsx';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';

const BillWiseHsn = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const [data,setData] = useState([])
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
    const fixedOutlet = { id: outletId, fullname: outletName };
    const [supplier, setSupplier] = useState([]);
    const roleId = localStorage.getItem("role_id")
    const[cust, setCust] = useState(null)
    const [dateLimit, setDateLimit] = useState({
      fromDate : moment().subtract(1, 'months').format(),
      toDate : moment().format()
    })
    function handleChange(e, name) {
      setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
    }

    function getGstLedger (){
      const postData = {
        from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
        to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
      }
        axios.post(`/v1/reports/outlet_sales/hsn/gstledger/withDate/${cust!==null ? cust.id : fixedOutlet.id}`,postData)
        .then(res=>{
          console.log(res.data)
            setData(res.data.outlet_sales)  
        })
        .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
        })
    }
    function getSupplierData() {
      axios
        .get("/v1/outlet/list/1")
        .then((res) => {
          setSupplier(res.data);
          _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
        })
        .catch((err) => {
          dispatch(setSnackbar(true, "error", err.response.data.error));
        });
    }
    // function exportToExcel() {
    //     const wb = XLSX.utils.book_new();
    //     const wsData = data.map(item => [
    //         moment(item.docdate).format('DD-MM-YYYY'),
    //         item.docno,
    //         item.hsn,
    //         item.gst_per,
    //         item.qty,
    //         item.amount,
    //         item.gst_amt / 2,
    //         item.gst_amt / 2,
    //         item.gst_amt,
    //         parseFloat(item.amount + item.gst_amt + item.igst_amt + item.cess_amt).toFixed(2)
    //     ]);

    //     const ws = XLSX.utils.aoa_to_sheet([
    //         ['Sales', '', '', '', '', '', '', '', '', ''],
    //         ['Date', 'Bill No', 'HSN', 'Tax PER %', 'Qty', 'Base Value', 'CGST', 'SGST', 'Total Tax', 'MRP'],
    //         ...wsData
    //     ]);

    //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    //     XLSX.writeFile(wb, "Bill_Wise__Hsn_Report.xlsx");
    // }

  //   function exportToExcel() {
  //     const wb = XLSX.utils.book_new();
  
  //     // Prepare the data rows
  //     const wsData = data.map(item => [
  //         moment(item.docdate).format('DD-MM-YYYY'),
  //         item.docno,
  //         item.hsn,
  //         item.gst_per,
  //         item.qty,
  //         item.amount,
  //         item.gst_amt / 2,
  //         item.gst_amt / 2,
  //         item.gst_amt,
  //         parseFloat(item.amount + item.gst_amt + item.igst_amt + item.cess_amt).toFixed(2)
  //     ]);
  
  //     // Add total values as the last row
  //     wsData.push([
  //         '', '', '', '', '', 
  //         totalWithoutTax.toFixed(2),
  //         totalCGST.toFixed(2),
  //         totalSGST.toFixed(2),
  //         totalTax.toFixed(2),
  //         totalMRP.toFixed(2)
  //     ]);
  
  //     const ws = XLSX.utils.aoa_to_sheet([
  //         ['Sales', '', '', '', '', '', '', '', '', ''],
  //         ['Date', 'Bill No', 'HSN', 'Tax PER %', 'Qty', 'Base Value', 'CGST', 'SGST', 'Total Tax', 'MRP'],
  //         ...wsData
  //     ]);
  
  //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  //     XLSX.writeFile(wb, "Bill_Wise_Hsn_Report.xlsx");
  // }
  const sortedData = _.sortBy(data, [item => moment(item.docdate).toDate()]);

  // function exportToExcel() {
  //   const wb = XLSX.utils.book_new();
  
  //   // Sort the data by Date and then by Bill No
  //   const sortedData = data.slice().sort((a, b) => {
  //     // Sort by date first (ascending)
  //     const dateA = new Date(a.docdate);
  //     const dateB = new Date(b.docdate);
  //     if (dateA < dateB) return -1;
  //     if (dateA > dateB) return 1;
  
  //     // If dates are the same, sort by bill number (ascending)
  //     return a.docno.localeCompare(b.docno);
  //   });
  
  //   // Prepare the data rows
  //   const wsData = sortedData.map(item => [
  //     moment(item.docdate).format('DD-MM-YYYY'),
  //     item.docno,
  //     item.hsn,
  //     // item.gst_per,
      
  //     // item.qty,
  //     parseFloat(item.gst_per).toFixed(0),
  //     parseFloat(item.qty).toFixed(0),
  //     parseFloat(item.amount).toFixed(2), // Rounding amount
  //     (item.gst_amt / 2).toFixed(2), // Rounding CGST
  //     (item.gst_amt / 2).toFixed(2), // Rounding SGST
  //     parseFloat(item.gst_amt).toFixed(2), // Rounding total tax
  //     Math.round(parseFloat(item.amount) + parseFloat(item.gst_amt) + parseFloat(item.igst_amt )+ parseFloat(item.cess_amt)).toFixed(2)
  //   ]);
  //  // Add a blank row for spacing before the total row
  //  wsData.push(['', '', '', '', '', '', '', '', '', '']);
  //   // Add total values as the last row
  //   wsData.push([
  //     'Total:', '', '', '', '',
  //     // '', '', '', '', '', 
  //     totalWithoutTax.toFixed(2),
  //     totalCGST.toFixed(2),
  //     totalSGST.toFixed(2),
  //     totalTax.toFixed(2),
  //     totalMRP.toFixed(2)
  //   ]);
  
  //   const ws = XLSX.utils.aoa_to_sheet([
  //     ['Sales', '', '', '', '', '', '', '', '', '', ''],
  //     ['Date', 'Bill No', 'HSN', 'Tax PER %', 'Qty', 'Base Value', 'CGST', 'SGST', 'Total Tax', 'MRP'],
  //     ...wsData
  //   ]);
  //   const alignment = {
  //     horizontal: 'center',  // Center-align the content
  //     vertical: 'center',    // Center vertically
  //     wrapText: true         // Enable text wrapping
  //   }
  //    // Style the entire worksheet (alignment and text wrap)
  // const cellRange = XLSX.utils.decode_range(ws['!ref']);
  // for (let row = cellRange.s.r; row <= cellRange.e.r; row++) {
  //   for (let col = cellRange.s.c; col <= cellRange.e.c; col++) {
  //     const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
  //     if (!ws[cellRef]) continue;

  //         // Apply default alignment
  //         ws[cellRef].s = { alignment };
  //   }
  // }

  // // Set column widths to accommodate full text
  // ws['!cols'] = [
  //   { wch: 15 }, // Width for Date
  //   { wch: 20 }, // Width for Bill No
  //   // { wch: 15 }, // Width for HSN
  //   // { wch: 10 }, // Width for Tax %
  //   // { wch: 15 }, // Width for Qty
  //   // { wch: 20 }, // Width for Base Value
  //   // { wch: 15 }, // Width for CGST
  //   // { wch: 15 }, // Width for SGST
  //   // { wch: 20 }, // Width for Total Tax
  //   // { wch: 20 }  // Width for MRP
  // ];
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  //   XLSX.writeFile(wb, "Bill_Wise_Hsn_Report.xlsx");
  // }

  //
  function exportToExcel() {
    const wb = XLSX.utils.book_new();
  
    // Sort the data by Date and then by Bill No
    const sortedData = data.slice().sort((a, b) => {
      // Sort by date first (ascending)
      const dateA = new Date(a.docdate);
      const dateB = new Date(b.docdate);
      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
  
      // If dates are the same, sort by bill number (ascending)
      return a.docno.localeCompare(b.docno);
    });
  
    // Prepare the data rows, formatting numeric fields to 2 decimal places
    // const wsData = sortedData.map(item => [
    //   moment(item.docdate).format('DD-MM-YYYY'),  // Date as string
    //   item.docno,  // Bill No as string
    //   item.hsn,    // HSN as string
    //   Number(item.gst_per).toFixed(2),  // Tax percentage with 2 decimals
    //   Number(item.qty).toFixed(2),      // Quantity with 2 decimals
    //   Number(item.amount).toFixed(2),   // Amount without tax with 2 decimals
    //   (Number(item.gst_amt) / 2).toFixed(2), // CGST with 2 decimals
    //   (Number(item.gst_amt) / 2).toFixed(2), // SGST with 2 decimals
    //   Number(item.gst_amt).toFixed(2),     // Total Tax with 2 decimals
    //   (Number(item.amount) + Number(item.gst_amt) + Number(item.igst_amt) + Number(item.cess_amt)).toFixed(2)  // Total MRP with 2 decimals
    // ]);
    const wsData = sortedData.map(item => [
      moment(item.docdate).format('DD-MM-YYYY'),  // Date as string
      item.docno,                                 // Bill No as string
      item.hsn,                                   // HSN as string
      Number(item.gst_per.toFixed(0)),            // Tax percentage with 2 decimal places
      Number(item.qty.toFixed(0)),                // Quantity with 2 decimal places
      Number(item.amount.toFixed(0)),             // Amount without tax with 2 decimal places
      Number((item.gst_amt / 2).toFixed(0)),      // CGST with 2 decimal places
      Number((item.gst_amt / 2).toFixed(0)),      // SGST with 2 decimal places
      Number(item.gst_amt.toFixed(0)),            // Total Tax with 2 decimal places
      Number((item.amount + item.gst_amt + item.igst_amt + item.cess_amt).toFixed(0))  // Total MRP with 2 decimal places
    ]);
    // Add a blank row for spacing before the total row
    wsData.push(['', '', '', '', '', '', '', '', '', '']);
  
    // Add total values as the last row, formatted to 2 decimal places
    wsData.push([
      'Total:', '', '', '', '',
      Number(totalWithoutTax).toFixed(0),
      Number(totalCGST).toFixed(0),
      Number(totalSGST).toFixed(0),
      Number(totalTax).toFixed(0),
      Number(totalMRP).toFixed(0)
    ]);
  
    // Create the sheet and set the alignment and wrapping
    const ws = XLSX.utils.aoa_to_sheet([
      ['Sales', '', '', '', '', '', '', '', '', ''],
      ['Date', 'Bill No', 'HSN', 'Tax PER %', 'Qty', 'Base Value', 'CGST', 'SGST', 'Total Tax', 'MRP'],
      ...wsData
    ]);
  
    const alignment = {
      horizontal: 'center',
      vertical: 'center',
      wrapText: true
    };
  
    // Apply alignment to all cells
    const cellRange = XLSX.utils.decode_range(ws['!ref']);
    for (let row = cellRange.s.r; row <= cellRange.e.r; row++) {
      for (let col = cellRange.s.c; col <= cellRange.e.c; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
        if (!ws[cellRef]) continue;
        ws[cellRef].s = { alignment };
      }
    }
  
    // Set column widths to accommodate full text
    ws['!cols'] = [
      { wch: 15 }, // Date
      { wch: 20 }, // Bill No
      { wch: 15 }, // HSN
      { wch: 10 }, // Tax %
      { wch: 15 }, // Qty
      { wch: 20 }, // Base Value
      { wch: 15 }, // CGST
      { wch: 15 }, // SGST
      { wch: 20 }, // Total Tax
      { wch: 20 }  // MRP
    ];
  
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Bill Wise HSN Report");
  
    // Write the Excel file
    XLSX.writeFile(wb, "Bill_Wise_Hsn_Report.xlsx");
  }
  
  // function exportToExcel() {
  //   const wb = XLSX.utils.book_new();
  
  //   // Sort the data by Date and then by Bill No
  //   const sortedData = data.slice().sort((a, b) => {
  //     // Sort by date first (ascending)
  //     const dateA = new Date(a.docdate);
  //     const dateB = new Date(b.docdate);
  //     if (dateA < dateB) return -1;
  //     if (dateA > dateB) return 1;
  
  //     // If dates are the same, sort by bill number (ascending)
  //     return a.docno.localeCompare(b.docno);
  //   });
  
  //   // Prepare the data rows, making sure numeric fields are passed as actual numbers
  //   const wsData = sortedData.map(item => [
  //     moment(item.docdate).format('DD-MM-YYYY'),  // Date as string
  //     item.docno,  // Bill No as string
  //     item.hsn,    // HSN as string
  //     Number(item.gst_per),  // Tax percentage as number
  //     Number(item.qty),      // Quantity as number
  //     Number(item.amount),   // Amount without tax as number
  //     Number(item.gst_amt / 2), // CGST as number
  //     Number(item.gst_amt / 2), // SGST as number
  //     Number(item.gst_amt),     // Total Tax as number
  //     Number(item.amount + item.gst_amt + item.igst_amt + item.cess_amt)  // Total MRP as number
  //   ]);
  
  //   // Add a blank row for spacing before the total row
  //   wsData.push(['', '', '', '', '', '', '', '', '', '']);
  
  //   // Add total values as the last row, ensure totals are numbers
  //   wsData.push([
  //     'Total:', '', '', '', '',
  //     Number(totalWithoutTax),
  //     Number(totalCGST),
  //     Number(totalSGST),
  //     Number(totalTax),
  //     Number(totalMRP)
  //   ]);
  
  //   // Create the sheet and set the alignment and wrapping
  //   const ws = XLSX.utils.aoa_to_sheet([
  //     ['Sales', '', '', '', '', '', '', '', '', ''],
  //     ['Date', 'Bill No', 'HSN', 'Tax PER %', 'Qty', 'Base Value', 'CGST', 'SGST', 'Total Tax', 'MRP'],
  //     ...wsData
  //   ]);
  
  //   const alignment = {
  //     horizontal: 'center',
  //     vertical: 'center',
  //     wrapText: true
  //   };
  
  //   // Apply alignment to all cells
  //   const cellRange = XLSX.utils.decode_range(ws['!ref']);
  //   for (let row = cellRange.s.r; row <= cellRange.e.r; row++) {
  //     for (let col = cellRange.s.c; col <= cellRange.e.c; col++) {
  //       const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
  //       if (!ws[cellRef]) continue;
  //       ws[cellRef].s = { alignment };
  //     }
  //   }
  
  //   // Set column widths to accommodate full text
  //   ws['!cols'] = [
  //     { wch: 15 }, // Date
  //     { wch: 20 }, // Bill No
  //     { wch: 15 }, // HSN
  //     { wch: 10 }, // Tax %
  //     { wch: 15 }, // Qty
  //     { wch: 20 }, // Base Value
  //     { wch: 15 }, // CGST
  //     { wch: 15 }, // SGST
  //     { wch: 20 }, // Total Tax
  //     { wch: 20 }  // MRP
  //   ];
  
  //   // Append the worksheet to the workbook
  //   XLSX.utils.book_append_sheet(wb, ws, "Bill Wise HSN Report");
  
  //   // Write the Excel file
  //   XLSX.writeFile(wb, "Bill_Wise_Hsn_Report.xlsx");
  // }
  
  
    useEffect(() => {
      getSupplierData();
    }, []);
    useEffect(()=>{
        getGstLedger()
    },[dateLimit,cust])
    const totals = data.reduce(
      (acc, val) => {
        acc.amount += parseFloat(val.amount || 0);
        acc.gst_amt += parseFloat(val.gst_amt || 0);
        acc.igst_amt += parseFloat(val.igst_amt || 0);
        acc.cess_amt += parseFloat(val.cess_amt || 0);
        return acc;
      },
      { amount: 0, gst_amt: 0, igst_amt: 0, cess_amt: 0 }
    );
  
    const totalWithoutTax = totals.amount;
    const totalCGST = totals.gst_amt / 2;
    const totalSGST = totals.gst_amt / 2;
    const totalTax = totals.gst_amt;
    const totalMRP = Math.round(totals.amount + totals.gst_amt + totals.igst_amt + totals.cess_amt);
  
  return (
<Fragment>
    <Helmet><title>Bill Wise Hsn Report</title></Helmet>
    <Typography variant='h6'>Bill Wise Hsn Report</Typography>
    <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid className='text-end my-2'>
    <Button onClick={exportToExcel} variant="outlined" > Export to Excel <SimCardDownloadOutlinedIcon /></Button>
      </Grid>
    <Grid className='flex'>
        <TableContainer className={classes.tblRoot} sx={{height:"500px !important" , overflow:"auto"}}>
            <Table>
                <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
                    <TableRow className={classes.tablrow} >
                        <TableCell sx={{borderLeft:`1px solid #ccc`}} className={classes.tblContentCell} colSpan={12} align='center'>Sales</TableCell>
                    </TableRow>
                    <TableRow className={classes.tablrow}>
                        <TableCell sx={{borderLeft:`1px solid #ccc`}}>Date</TableCell>
                        <TableCell>Bill No</TableCell>
                        <TableCell>HSN</TableCell>
                        <TableCell >Tax PER %</TableCell>
                        <TableCell>Qty</TableCell>
                        <TableCell >Base Value</TableCell>
                        <TableCell>CGST</TableCell>
                        <TableCell>SGST</TableCell>
                        <TableCell>Total Tax</TableCell>
                        <TableCell>MRP</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                          {sortedData.length > 0 && _.map(sortedData,(val, idx)=>(    
                     <TableRow className={classes.tablrow1} key={idx}>
                        <TableCell sx={{borderLeft: `1px solid #ccc`,textAlign:"center !important"}}>{moment(val.docdate).format('DD-MM-YYYY')}</TableCell>
                            <TableCell>{val.docno}</TableCell>
                            <TableCell>{val.hsn}</TableCell>
                            <TableCell  >{val.gst_per}</TableCell>
                            <TableCell>{val.qty}</TableCell>
                            <TableCell>{parseFloat(val.amount).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt / 2).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt / 2).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt).toFixed(0) }</TableCell>
                            {/* <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{parseFloat(val.amount + val.gst_amt + val.igst_amt +val.cess_amt).toFixed(2)}</TableCell> */}
                            <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{Math.round(parseFloat(val.amount + val.gst_amt + val.igst_amt +val.cess_amt).toFixed(0)).toFixed(0)}</TableCell>
                     
                     </TableRow>
                        ))}
                </TableBody>
                <TableFooter sx={{ position: "sticky", bottom: 0, backgroundColor: "white" }}>
                  <TableRow className={classes.tablrow1}>
                    <TableCell sx={{ borderLeft: `1px solid #ccc`,textAlign:"right",fontWeight:"bold",fontSize:16,color:"#000" }} colSpan={5}>Total</TableCell>
                    <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalWithoutTax.toFixed(0)}</TableCell>
                    <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalCGST.toFixed(0)}</TableCell>
                    <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalSGST.toFixed(0)}</TableCell>
                    <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalTax.toFixed(0)}</TableCell>
                    <TableCell sx={{ borderRight: `1px solid #ccc` ,textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalMRP.toFixed(0)}</TableCell>
                  </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    </Grid>
</Fragment>
  )
}

export default memo(BillWiseHsn)